export default {
    url: '/by_first_purchase',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 901,
        title: 'By first purchase',
        role: 'conversion_rate',
    },
};
